// This is used to determine if a user is authenticated and
// if they are allowed to visit the page they navigated to.

// If they are: they proceed to the page
// If not: they are redirected to the login page.
import React, { useEffect } from 'react'
import { Navigate, useNavigate, useLocation }   from 'react-router-dom'

/**
 * Shared
 */
import * as UserSessionStore from '@features/auth/stores/user-session-store';
import { isFalsy } from '@shared/lib/helpers/common';
import { LocalStorage } from '@shared/services/main/storage';
import ROUTES from '@shared/lib/constants/routes';
import { openLoginModal } from 'mfe/auth-bridge';

/**
 * This only implements the login form
 *
 * @class  LockedRoutes (name)
 * @param  {Object}     arg1 The argument 1
 * @param  {Component}  arg1.component The component
 */
const PrivateRoute = ({ component: Component }) => {
  const [{user}, ] = UserSessionStore.useUserSessionContext();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Check both store and LocalStorage as fallback
  const storeUser = user;
  const localStorageUser = LocalStorage.get('user');
  const isAuthenticated = !isFalsy(storeUser) || !isFalsy(localStorageUser);

  // Debug logging (remove in production if needed)
  if (process.env.NODE_ENV === 'development') {
    console.log('[PrivateRoute]', {
      isAuthenticated,
      storeUser: storeUser ? 'exists' : 'null/undefined',
      localStorageUser: localStorageUser ? 'exists' : 'null/undefined',
      currentPath: location.pathname
    });
  }

  // Handle redirect in useEffect to avoid issues with nested routers
  useEffect(() => {
    if (!isAuthenticated) {
      if (process.env.NODE_ENV === 'development') {
        console.log('[PrivateRoute] useEffect: Unauthenticated, opening login modal');
      }
      openLoginModal();
      // Keep navigation inside sportsbook base route.
      navigate(ROUTES.DEFAULT, { replace: true });
    }
  }, [isAuthenticated, location.pathname, navigate]);

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.DEFAULT} replace />;
  }

  return <Component />;
}

export default PrivateRoute;

